if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute("max");
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// thumbnail
var product_slider_thumbs = new Swiper(
  ".section-main-products .product-thumbnail-slider",
  {
    slidesPerView: 5,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      749: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1199: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
  }
);

// Main slider
var inv__slider = document.querySelector(
  ".section-main-products .product__slider-container"
);
if (inv__slider) {
  var inv_product_slider = new Swiper(
    ".section-main-products .product__slider-container",
    {
      spaceBetween: 10,
      thumbs: {
        swiper: product_slider_thumbs,
      },
      navigation: {
        nextEl: ".main-image-button-next",
        prevEl: ".main-image-button-prev",
      },
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    }
  );

  // Listen for slide change events on the main slider
  inv_product_slider.on("slideChange", function () {
    var activeIndex = inv_product_slider.activeIndex;
    product_slider_thumbs.slides.removeClass("swiper-slide-active");
    product_slider_thumbs.slides
      .eq(activeIndex)
      .addClass("swiper-slide-active");
  });

  // Listen for click events on thumbnails
  product_slider_thumbs.on("click", function () {
    var clickedIndex = product_slider_thumbs.clickedIndex;
    console.log(clickedIndex);
    inv_product_slider.slideTo(clickedIndex);
  });
}

// variant radio change to change image
var variantRadioButtons = document.querySelectorAll(
  ".section-main-products .variantRadioButton"
);
if (variantRadioButtons) {
  variantRadioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function () {
      const radioDataIndex = radioButton.getAttribute("data-index");
      updateSwiperSlide(radioDataIndex);
    });
  });

  function updateSwiperSlide(variantIndex) {
    var mediaItems = document.querySelectorAll(
      ".section-main-products .product__media-item"
    );

    mediaItems.forEach(function (mediaItem) {
      var altMedia = mediaItem.getAttribute("data-media-attr");
      console.log(altMedia, variantIndex);
      if (altMedia == variantIndex) {
        var swiperSlideIndex = mediaItem.getAttribute(
          "data-swiper-slide-index"
        );
        inv_product_slider.slideTo(swiperSlideIndex);
      }
    });
  }
}